import {
	postYiqifeiXServicesRequest,
	postBIZServicesRequest
} from '@/utils/request'
var webconfig = require('@/utils/webconfig.js');

const bizApi = {
	/**
	 * 获取交易单列表（差旅宝）
	 * @description 文档地址：https://biz5xapi.yiqifei.com/Doc/Serving?id=94f5e94a8894a329da4488ef0c75f00f
	 */	
	GetBizSimTradeGetList(parm, callback) {
		postBIZServicesRequest('BizApi.LvRui.BizSimTradeGetList', parm, function(result) {
			callback(result);
		})
	},	
	/**
	 * AI下单简易接口
	 * @description 文档地址：https://biz5xapi.yiqifei.com/Doc/Serving?id=c2a29c6c7e4715d20869ecf3d3c79d43	 
	 */	
	AICreateOrder(parm, callback) {
		postBIZServicesRequest('BizApi.OpenAPI.Easy.AICreateOrder', parm, function(result) {
			callback(result);
		})
	},	
	
	/**
	 * LR userCode转5X userCode
	 * @description 文档地址：https://biz5xapi.yiqifei.com/Doc/Serving?id=aa5e916401f557e7952c2cd2baf1c41b
	 */	
	GetPlatformAccountByLoginName(parm, callback) {
		postBIZServicesRequest('BizApi.CRM.PlatformAccountByLoginName', parm, function(result) {
			callback(result);
		})
	},	
	/**
	 * 获取飞飞用户凭证
	 * @description 文档地址：https://bizapi.yiqifei.cn/Doc/Serving?id=737c81b66611014655b4e4e5d1b75f81	 
	 */	
	GetFeifeiAuth(parm, callback) {
		postBIZServicesRequest('BizApi.OpenAPI.ServiceCenter.FeifeiAuth', parm, function(result) {
			callback(result);
		})
	},	
	/**
	 * 获取酒店详情
	 * @description 文档地址：https://bizapi.yiqifei.cn/Doc/Serving?id=737c81b66611014655b4e4e5d1b75f81	 
	 */	
	GetOpenAPISKHotelHotelDetail(parm, callback) {
		postBIZServicesRequest('BizApi.OpenAPI.Hotel.HotelDetail', parm, function(result) {
			callback(result);		
		})
	},
	/**
	 * 备注、留言、行程单、退改签留言
	 * @description 文档地址：https://bizapi.yiqifei.cn/Doc/Serving?id=c64fbc6e4a77e6ec1e5632b83b2ba785
	 */	
	GetSalesOrderMessageAdd(parm, callback) {
		postBIZServicesRequest('BizApi.LvRui.SalesOrderMessageAdd', parm, function(result) {
			callback(result);
		})
	},
	/**
	 * 获取所有机场列表
	 * @description 接口名称：BizApi.Destination.AirportForAllGet
	 * @param {Object} parm - 请求参数
	 * @param {Function} callback - 回调函数
	 */	
	GetAirportForAll(parm, callback) {
		postBIZServicesRequest('BizApi.Destination.AirportForAllGet', parm, function(result) {
			callback(result);
		})
	},
};

export default bizApi;